import {useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import {navigationActionsTrackingData, navigationClickActions} from '@adv-mt/mt-navigation-actions'
import IconArrowLeft from '@adv-mt/mt-svg-icons/lib/ArrowLeftDefault'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'

import {BASE_CLASS} from './config.js'
import getDefaultBackUrl from './getDefaultBackUrl.js'

const BackButton = ({breadcrumb = [], hrefBack}) => {
  const {i18n, domain} = useContext(Context)
  const router = useRouter()
  const {track} = useAnalyticsTrack()

  const shouldGoBack = router?.location?.state?.shouldGoBack

  const handleClick = () => {
    track({event: navigationActionsTrackingData[navigationClickActions.BACK_ACTION].event})
    if (shouldGoBack) router.goBack()
  }

  const adsListPathPattern = domain.get('config').get('page').SECOND_HAND_PATH_PATTERN
  const href = shouldGoBack ? undefined : hrefBack || getDefaultBackUrl({breadcrumb, adsListPathPattern})

  return (
    <Button
      aria-label={i18n.t('COMMON.GO_BACK')}
      className={`${BASE_CLASS}-backButton`}
      href={href}
      intent={BUTTON_INTENTS.PRIMARY}
      onClick={handleClick}
      shape={BUTTON_SHAPES.CIRCLE}
      size={BUTTON_SIZES.LARGE}
      variant={BUTTON_VARIANTS.FLAT}
    >
      <IconArrowLeft size={ATOM_ICON_SIZES.medium} />
    </Button>
  )
}

BackButton.displayName = 'BackButton'
BackButton.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({url: PropTypes.string})),
  hrefBack: PropTypes.string
}

export default BackButton
